import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ShowApplication from "src/components/panel/municipality_nursery_application/show_application/ShowApplication";

const ShowApplicationsNurseryView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("show_application_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("show_application_title")} 
        subtitle={t("show_application_subtitle")}/>
        <ShowApplication/>
      </Sidebar>
    </>
  );
};

export default ShowApplicationsNurseryView;